import { colors } from "../../utils/const";

export const styles = {
  container: {
    display: "flex",
    flexWrap: { xs: "wrap", lg: "nowrap" },
    justifyContent: { xs: "start", lg: "space-between" },
    gap:{ xs:2,md:6},
  },
  title: {
    color: colors.orange,
    fontSize: "40px",
    fontWeight: "bold",
    pb:"24px"
  },
  desc: {
    color: colors.blue,
    fontWeight: "300",
    fontSize: "20px",
  },
  
};
